var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewMultipleTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.5 15.9",
    enableBackground: "new 0 0 17.5 15.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0099d2",
    strokeWidth: 2,
    d: "M12.7,3h3.8v12H7.1v-4.4"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0099d2",
    strokeWidth: 2,
    x1: 4.1,
    y1: 6.7,
    x2: 0.6,
    y2: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#0099d2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 7.1,
    cy: 4.6,
    r: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMultipleTasks);
export default __webpack_public_path__ + "static/media/viewMultipleTasks.8e4d51b6.svg";
export { ForwardRef as ReactComponent };